const HTML_ESCAPES = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

// Escape a value before interpolating it into a string rendered with v-html.
export function escapeHtml(value) {
  if (value === null || value === undefined) {
    return '';
  }
  return String(value).replace(/[&<>"']/g, ch => HTML_ESCAPES[ch]);
}

// Only allow absolute http(s) URLs in bound hrefs; blocks javascript:, data:, etc.
export function safeUrl(value) {
  if (typeof value !== 'string') {
    return undefined;
  }
  const trimmed = value.trim();
  return /^https?:\/\//i.test(trimmed) ? trimmed : undefined;
}



// WEBPACK FOOTER //
// ./src/utils/sanitize.js